<div class="gallery">
     {#each data as obj, index}
        <img
          src="assets/{obj.src}"
          class="gallery-image {obj.classes}"
          id="gallery-image-{index}"
          on:click={openModal}>
     {:else}
        <p>No images found!</p>
     {/each}
</div>

{#if modalSrc}
    <Modal src={modalSrc} on:close="{() => modalSrc=''}">
    </Modal>
{/if}

<script>
    import Modal from '../Components/Modal.svelte';
    let modalSrc = "";

    function openModal(event) {
        modalSrc = event.target.src;
    }

    function formatImageData(line) {
        let [src, classes] = line.split(',', 2);
        if (typeof(classes) == "undefined") {
           classes = "";
        } else {
           classes = classes.trim();
        }
        return {src: src.trim(), classes: classes};
    }
    export let data = [];
    const content = document.getElementById("content");

    fetch('image_links.txt')
    .then(response => response.text())
    .then((text) => data = text.trim().split("\n").map(formatImageData))
</script>

<style>
    img.gallery-image {
        cursor: zoom-in;
    }

    .gallery-image {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }


    .tall {
        grid-row: span 2;
    }

    .wide {
        grid-column: span 2;
    }

    .big {
        grid-row: span 2;
        grid-column: span 2;
    }

    .top {
        object-position: 50% 0%;
    }
</style>
